<template>
    <div id="Events">
        <mobileHeader v-if="isMobile == 'Mobile'" touterNum=3></mobileHeader>
        <Header v-else></Header>
        <backhead :title="titleLabel"></backhead>
        <div class="mainbox app-content" :class="{ Mobileclass: isMobile == 'Mobile' }">
            <!-- <h3 class="app-title">{{ h3Intro }}</h3> -->
            <div class="hasline">
                <!-- <p>{{ dec }}</p> -->
                <div class="list flex">
                    <div class="box" v-for="(item, index) in arrList" :key="index">
                        <img :src="item.image" alt="" class="pic">
                        <p class="tit app-title">{{item.title}}</p>
                    </div>
                    <div class="box" v-if="arrList.length % 4 > 1"></div>
                    <div class="box" v-if="arrList.length % 4 == 2"></div>
                </div>
            </div>
            <!-- <h3 class="app-title">{{ h3Recommend }}</h3> -->
            <div class="hasline" v-for="(item, index) in arrList" :key="index">
                <div class="imgtxt flex">
                    <img :src="item.image" alt="" class="pic" v-show="index % 2 == 0">
                    <div>
                        <h5 class="app-title">{{item.title}}</h5>
                        <p v-html="item.content"></p>
                    </div>
                    <img :src="item.image" alt="" class="pic" v-show="index % 2 != 0">
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
    import { ref, watch, computed } from 'vue';
    import { getshowList } from "../utils/gerData";
    import { currentLanguage } from "../utils/lang";
    import { backheadTitles, pageLabels,imageurl } from "../utils/i18nLabels";
    const isMobile = localStorage.getItem('userAgent')

    const arrList = ref([]);
    const titleLabel = computed(() => backheadTitles.events[currentLanguage.value || 'zh'])
    const h3Intro = computed(() => pageLabels.events.intro[currentLanguage.value || 'zh'])
    const h3Recommend = computed(() => pageLabels.events.service[currentLanguage.value || 'zh'])
    const dec = computed(() => pageLabels.events.dec[currentLanguage.value || 'zh'])
    // 获取列表数据
    function getList() {
        let queryParams = {
            page: 1,
            pageSize: 100,
            pid: 8
        }
        getshowList(queryParams).then(res => {
            const data = res.data
            data.list.map(item => {
                item.image = item.image ? imageurl + item.image : undefined
            })
            arrList.value = data.list;
        });
    }
    getList()

    watch(currentLanguage, () => {
        getList()
    })
</script>

<style scoped>
    #Events{
        overflow: hidden;
    }
    .mainbox{
        margin-top: 200px;
        text-align: left;
    }
    .hasline{
        border-bottom: 2px solid #f0f0f0;
        overflow: hidden;
        padding: 60px;
    }
    h3{
        font-size: 39px;
        color: #232323;
        font-weight: normal;
        padding: 60px 60px 0;
    }
    .list{
        flex-wrap: wrap;
        margin: 80px 0 40px 0;
        .box{
            width: 24%;
            .pic{
                width: 100%;
                height: 200px;
                object-fit: cover;
                display: block;
            }
            .tit{
                font-size: 25px;
                color: #000;
                margin: 10px 0;
            }
        }
    }
    .imgtxt{
        align-items: flex-start;
        img{
            width: 38%;
        }
        div{
            width: 58%;
        }
        h5{
            font-size: 28px;
            color: #000;
            margin-bottom: 20px;
        }
        p{
            color: #3f3f3f;
            font-size: 24px;
        }
    }

    .Mobileclass{
        margin-top: 160px;
        h3{
            font-size: 34px;
            padding: 0 22px;
        }
        .hasline{
            padding: 22px;
            border: none;
            .imgtxt {
                display: block;
                img{
                    width: 100%;
                    display: block;
                    margin: 10px 0;
                }
                div{
                    width: 100%;
                }
                h5{
                    font-size: 28px;
                    margin: 20px 0;
                }
            }
        }
        .list{
            display: block;
            margin: 20px 0 40px 0;
        }
        .box{
            width: 100%;
            .tit{
                font-size: 30px;
                margin: 10px 0 50px 0;
            }
        }
    }
</style>